import { render, staticRenderFns } from "./NewFrameDataModal.vue?vue&type=template&id=16d92432&scoped=true"
import script from "./NewFrameDataModal.vue?vue&type=script&lang=js"
export * from "./NewFrameDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d92432",
  null
  
)

export default component.exports